//handle nested section fields
export const flattenFields = (fields) => {
    if(!Array.isArray(fields)) return []
    const out = [];
    for(const field of fields) {
      if(field.type === 'section') {
        out.push(...flattenFields(field.fields || []))
      } else {
        out.push(field)
      }
    }
    return out
  }
  
  export const getFieldByType = (componentConfig = {}, type) => {
    const allFields = flattenFields(componentConfig?.fields || [])
    return allFields.find((field) => field?.type === type)
  }
  
  export const getImageField = (componentConfig = {}) => getFieldByType(componentConfig, 'image')
  